import LegalPage from "../../components/LegalPage";
import content from "../../legal/termsContent";

const Terms = () => <LegalPage title="Terms & Conditions" content={content} />;

export default Terms;
